import { Button } from "primereact/button";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ArrowIcon } from "../left-frame/LeftFrameSvgIcon";

export const GoBackButtonComponent = () => {
	const navigate = useNavigate();

	const location = useLocation();
	const previousRouteStarted = localStorage.getItem("previousRouteStarted");
	const previousRouteContinue = localStorage.getItem("previousRouteContinue");
	const previousRouteAfterFailed = localStorage.getItem("previousRouteAfterFailed");
	const previousRouteAfterPassed = localStorage.getItem("previousRouteAfterPassed");

	const goBack = () => {
		if (location.pathname === previousRouteStarted) {
			navigate(-2);
			localStorage.setItem("previousRouteStarted", "");
		} else if (location.pathname === previousRouteContinue) {
			navigate(-2);
			localStorage.setItem("previousRouteContinue", "");
		} else if (location.pathname === previousRouteAfterFailed) {
			navigate(-2);
			localStorage.setItem("previousRouteAfterFailed", "");
		} else if (location.pathname === previousRouteAfterPassed) {
			navigate(-2);
			localStorage.setItem("previousRouteAfterPassed", "");
		} else {
			navigate(-1);
		}
	};
	return (
		<DivContainer>
			{/modul\b/.test(location.pathname) && (
				<StyledButton
					className="mr-2 bg-transparent text-primary hover:text-primary border-none"
					onClick={() => goBack()}
					icon={<ArrowIcon></ArrowIcon>}
				>
					<span className="mb-1 ml-1">zurück</span>
				</StyledButton>
			)}
		</DivContainer>
	);
};

const DivContainer = styled.div`
	display: flex;
	height: 100%;
	align-items: center;
`;

const StyledButton = styled(Button)`
	font-size: 14px !important;
	padding: 0;
`;
